import { withTranslation } from "react-i18next";

import { Large } from "../Footer/styles";
import { useState } from "react";
import { Content, H6White, IconWrapper } from "../styles";
import { ModalButton } from "../../common/Modal/styles";
import Modal from "../../common/Modal";
import { Col, Row } from "antd";
import { Container, InfoSection } from "../PrivacyPolicyModal/styles";
import {
  ReadOutlined,
  CommentOutlined,
  GlobalOutlined,
  LockOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import { ModelComponentProps } from "../types";

const TermsOfServiceModal = ({ t }: ModelComponentProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
    <Large onClick={() => setIsModalOpen(true)}>{t("TermsOfService")}</Large>
      <Modal
        title={<H6White>{t('TermsOfService')}</H6White>}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={[
          <ModalButton key="back" onClick={() => setIsModalOpen(false)}>
            {t("Close")}
          </ModalButton>
        ]}
        width="min(900px, 90vw)"
      >
        <Row>
          <Col xs={24}>
            <Container>
              <InfoSection>
                <IconWrapper>
                  <ReadOutlined style={{ fontSize: '1.6rem'}} />
                </IconWrapper>
                <Content>{t('WhatHiddenTenthsProvides')}</Content>
              </InfoSection>
              <InfoSection>
                <IconWrapper>
                  <CommentOutlined style={{ fontSize: '1.6rem'}} />
                </IconWrapper>
                <Content>{t('WhatReviewsReflect')}</Content>
              </InfoSection>
              <InfoSection>
                <IconWrapper>
                  <GlobalOutlined style={{ fontSize: '1.6rem'}} />
                </IconWrapper>
                <Content>{t('SubmissionsMayBePublic')}</Content>
              </InfoSection>
              <InfoSection>
                <IconWrapper>
                  <LockOutlined style={{ fontSize: '1.6rem'}} />
                </IconWrapper>
                <Content>{t('WhatPrivateFeedbackIsIntendedFor')}</Content>
              </InfoSection>
              <InfoSection>
                <IconWrapper>
                  <SafetyCertificateOutlined style={{ fontSize: '1.6rem'}} />
                </IconWrapper>
                <Content>{t('InformationIsNotSold')}</Content>
              </InfoSection>
            </Container>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default withTranslation()(TermsOfServiceModal);
